function Comp31() {
    $(".comp-31").each(function () {
        const comp = $(this);
        const btns = comp.find(".comp-31-tabLink a");
        const contents = comp.find(".comp-31-tabPane");

        btns.first().addClass("active");
        contents.hide().first().addClass("active").show();

        btns.on("click", function (e) {
            e.preventDefault();
            const target = $(this).attr("href");

            btns.removeClass("active");
            contents.removeClass("active").hide();

            $(this).addClass("active");
            comp.find(target).addClass("active").fadeIn(200);
        });
    });
}
Comp31();
